import {ChangeDetectionStrategy, Component, DOCUMENT, Inject, OnDestroy, OnInit} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {RouterModule} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {MainPagesContainerComponent} from '../main-pages-container/main-pages-container.component';

@Component({
    selector: 'app-qa',
    templateUrl: './qa.component.html',
    styleUrls: ['../main.pages.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MainPagesContainerComponent,
        MatButtonModule,
        RouterModule,
        TranslatePipe
    ]
})
export class QaComponent implements OnInit, OnDestroy {

    private static readonly JSON_LD_ID = 'ld-faqpage'

    // Вопросы-ответы дублируют видимый контент qa.component.html (страница только для EN-версии).
    private readonly faq: Array<{ question: string, answer: string }> = [
        {
            question: 'What is a sex chat?',
            answer: 'A sex chat is an online conversation between users about intimate and erotic topics. It can involve text messaging, voice calls, and video chats.'
        },
        {
            question: 'What\u2019s the difference between sex chat, adult chat, and virt chat?',
            answer: 'Sex chat is a general term for online conversations about intimacy, including text, voice, and video. Adult chat is a broader category that includes not only erotic discussions but also topics like fetishes, BDSM, and other adult-related interests. Virt chat (virtual sex) is a type of online interaction focused on sexual roleplay through text, voice, or video, often without real-life contact.'
        },
        {
            question: 'Is sex chat free to use?',
            answer: 'Many sex chat platforms offer free access, but some features\u2014such as private rooms, video chats, and premium content\u2014may require payment.'
        },
        {
            question: 'How do I choose a good sex chat platform?',
            answer: 'Look for anonymity and security, a user-friendly interface, an active community, and free and premium features.'
        },
        {
            question: 'Is sex chat anonymous?',
            answer: 'Most platforms allow anonymous chatting, but some may require registration. Always check the platform\u2019s privacy settings.'
        },
        {
            question: 'What are the rules for sex chat?',
            answer: 'Respect your chat partner\u2019s boundaries, do not share personal information, avoid harassment and pressure, and follow the platform\u2019s guidelines.'
        },
        {
            question: 'Can I find a partner in a sex chat?',
            answer: 'It\u2019s possible, but most users engage in virtual-only interactions rather than real-life meetups.'
        },
        {
            question: 'How is adult chat different from regular chat?',
            answer: 'Adult chat is designed for 18+ users and focuses on flirtation, sexual fantasies, roleplay, and discussions about intimacy.'
        },
        {
            question: 'Are there age restrictions?',
            answer: 'Yes, most adult chat platforms require users to be 18 or older.'
        },
        {
            question: 'What is virtual sex chat (virt chat)?',
            answer: 'Virt chat, or virtual sex, is an intimate online interaction where partners engage in erotic conversations via text, voice, or video. It often includes roleplay and shared fantasies.'
        },
        {
            question: 'How can I protect my privacy in a sex chat?',
            answer: 'Use a nickname instead of your real name, never share personal details (address, phone number), and avoid clicking on suspicious links.'
        },
    ]

    constructor(@Inject(DOCUMENT) private readonly document: Document) {
    }

    ngOnInit() {
        const data = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: this.faq.map(item => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: item.answer,
                },
            })),
        }

        this.removeJsonLd()

        const script = this.document.createElement('script')
        script.setAttribute('type', 'application/ld+json')
        script.setAttribute('id', QaComponent.JSON_LD_ID)
        script.textContent = JSON.stringify(data)
        this.document.head.appendChild(script)
    }

    ngOnDestroy() {
        this.removeJsonLd()
    }

    private removeJsonLd() {
        const existing = this.document.getElementById(QaComponent.JSON_LD_ID)
        if (existing) {
            existing.remove()
        }
    }
}
